var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/workspace/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _require = require("date-fns"),
    getWeek = _require.getWeek,
    subWeeks = _require.subWeeks,
    subYears = _require.subYears,
    startOfMinute = _require.startOfMinute,
    getUnixTime = _require.getUnixTime;

var _require2 = require('./../constants'),
    TWENTY_FOUR_HOURS = _require2.TWENTY_FOUR_HOURS;

var _require3 = require('./exchange'),
    dayData = _require3.dayData,
    tokenHourData = _require3.tokenHourData,
    tokenDayData = _require3.tokenDayData,
    pairHourData = _require3.pairHourData,
    pairDayData = _require3.pairDayData,
    ethPriceHourly = _require3.ethPriceHourly;

module.exports = {
  factory: function factory() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data, weeklyData, startIndexWeekly, currentWeek;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dayData();

            case 2:
              data = _context.sent;
              weeklyData = [];
              startIndexWeekly = -1;
              currentWeek = -1;
              data.forEach(function (entry, i) {
                var week = getWeek(data[i].date);

                if (week !== currentWeek) {
                  currentWeek = week;
                  startIndexWeekly++;
                }

                weeklyData[startIndexWeekly] = weeklyData[startIndexWeekly] || {};
                weeklyData[startIndexWeekly].date = data[i].date;
                weeklyData[startIndexWeekly].weeklyVolumeUSD = (weeklyData[startIndexWeekly].weeklyVolumeUSD ? weeklyData[startIndexWeekly].weeklyVolumeUSD : 0) + data[i].volumeUSD;
              });
              return _context.abrupt("return", [data, weeklyData]);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  tokenHourly: function tokenHourly(_ref) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref$token_address, token_address, _ref$startTime, startTime, _yield$Promise$all, _yield$Promise$all2, tokenData, ethPrices;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref$token_address = _ref.token_address, token_address = _ref$token_address === void 0 ? undefined : _ref$token_address, _ref$startTime = _ref.startTime, startTime = _ref$startTime === void 0 ? undefined : _ref$startTime;

              if (token_address) {
                _context2.next = 3;
                break;
              }

              throw new Error("sushi-data: Token address undefined");

            case 3:
              _context2.next = 5;
              return Promise.all([tokenHourData({
                minTimestamp: startTime,
                token_address: token_address
              }), ethPriceHourly({
                minTimestamp: startTime
              })]);

            case 5:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              tokenData = _yield$Promise$all2[0];
              ethPrices = _yield$Promise$all2[1];
              tokenData = tokenData.map(function (tokenEntry) {
                var ethPriceUSD = ethPrices.find(function (ethEntry) {
                  return ethEntry.timestamp === tokenEntry.timestamp;
                }).priceUSD;
                return _objectSpread(_objectSpread({}, tokenEntry), {}, {
                  priceUSD: tokenEntry.derivedETH * ethPriceUSD
                });
              });
              tokenData = tokenData.map(function (tokenEntry, i) {
                return _objectSpread(_objectSpread({}, tokenEntry), {}, {
                  volume: tokenData[i - 1] ? tokenEntry.volume - tokenData[i - 1].volume : undefined,
                  volumeUSD: tokenData[i - 1] ? tokenEntry.volumeUSD - tokenData[i - 1].volumeUSD : undefined,
                  untrackedVolumeUSD: tokenData[i - 1] ? tokenEntry.untrackedVolumeUSD - tokenData[i - 1].untrackedVolumeUSD : undefined,
                  txCount: tokenData[i - 1] ? tokenEntry.txCount - tokenData[i - 1].txCount : undefined,
                  open: tokenEntry.priceUSD,
                  close: tokenData[i + 1] ? tokenData[i + 1].priceUSD : undefined
                });
              });
              return _context2.abrupt("return", tokenData);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  tokenDaily: function tokenDaily() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _ref2, _ref2$token_address, token_address, data, endTime, startTime, dayIndexSet, dayIndexArray, timestamp, latestLiquidity, latestLiquidityUSD, latestLiquidityETH, latestPriceUSD, index, nextDay, currentDayIndex;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref2 = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref2$token_address = _ref2.token_address, token_address = _ref2$token_address === void 0 ? undefined : _ref2$token_address;

              if (token_address) {
                _context3.next = 3;
                break;
              }

              throw new Error("sushi-data: Token address undefined");

            case 3:
              _context3.next = 5;
              return tokenDayData({
                token_address: token_address
              });

            case 5:
              data = _context3.sent;
              endTime = getUnixTime(new Date());
              startTime = getUnixTime(startOfMinute(subYears(new Date(), 1)));
              dayIndexSet = new Set();
              dayIndexArray = [];
              data.forEach(function (dayData, i) {
                // add the day index to the set of days
                dayIndexSet.add((data[i].timestamp / TWENTY_FOUR_HOURS).toFixed(0));
                dayIndexArray.push(data[i]);
              }); // fill in empty days

              timestamp = data[0] && data[0].timestamp ? data[0].timestamp : startTime;
              latestLiquidity = data[0] && data[0].liquidity;
              latestLiquidityUSD = data[0] && data[0].liquidityUSD;
              latestLiquidityETH = data[0] && data[0].liquidityETH;
              latestPriceUSD = data[0] && data[0].priceUSD;
              index = 1;

              while (timestamp < endTime - TWENTY_FOUR_HOURS) {
                nextDay = timestamp + TWENTY_FOUR_HOURS;
                currentDayIndex = (nextDay / TWENTY_FOUR_HOURS).toFixed(0);

                if (!dayIndexSet.has(currentDayIndex)) {
                  data.push({
                    id: "".concat(data[0].id.split("-")[0], "-").concat(nextDay / TWENTY_FOUR_HOURS),
                    date: new Date(nextDay * 1000),
                    timestamp: nextDay,
                    volume: 0,
                    volumeETH: 0,
                    volumeUSD: 0,
                    liquidity: latestLiquidity,
                    liquidityETH: latestLiquidityETH,
                    liquidityUSD: latestLiquidityUSD,
                    priceUSD: latestPriceUSD,
                    txCount: 0
                  });
                } else {
                  latestLiquidity = dayIndexArray[index].liquidity;
                  latestLiquidityETH = dayIndexArray[index].liquidityETH;
                  latestLiquidityUSD = dayIndexArray[index].liquidityUSD;
                  latestPriceUSD = dayIndexArray[index].priceUSD;
                  index = index + 1;
                }

                timestamp = nextDay;
              }

              data = data.sort(function (a, b) {
                return parseInt(a.timestamp) > parseInt(b.timestamp) ? 1 : -1;
              });
              return _context3.abrupt("return", data);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  pairHourly: function pairHourly(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref3$pair_address, pair_address, _ref3$startTime, startTime, pairData;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref3$pair_address = _ref3.pair_address, pair_address = _ref3$pair_address === void 0 ? undefined : _ref3$pair_address, _ref3$startTime = _ref3.startTime, startTime = _ref3$startTime === void 0 ? undefined : _ref3$startTime;

              if (pair_address) {
                _context4.next = 3;
                break;
              }

              throw new Error("sushi-data: Pair address undefined");

            case 3:
              _context4.next = 5;
              return pairHourData({
                minTimestamp: startTime,
                pair_address: pair_address
              });

            case 5:
              pairData = _context4.sent;
              pairData = pairData.map(function (pairEntry, i) {
                return _objectSpread(_objectSpread({}, pairEntry), {}, {
                  volumeToken0: pairData[i - 1] ? pairEntry.volumeToken0 - pairData[i - 1].volumeToken0 : undefined,
                  volumeToken1: pairData[i - 1] ? pairEntry.volumeToken1 - pairData[i - 1].volumeToken1 : undefined,
                  rate0: {
                    open: pairEntry.token0Price,
                    close: pairData[i + 1] ? pairData[i + 1].token0Price : undefined
                  },
                  rate1: {
                    open: pairEntry.token1Price,
                    close: pairData[i + 1] ? pairData[i + 1].token1Price : undefined
                  },
                  txCount: pairData[i - 1] ? pairEntry.txCount - pairData[i - 1].txCount : undefined
                });
              });
              return _context4.abrupt("return", pairData);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  pairDaily: function pairDaily() {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _ref4, _ref4$pair_address, pair_address, data, endTime, startTime, dayIndexSet, dayIndexArray, timestamp, latestLiquidityUSD, index, nextDay, currentDayIndex;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _ref4 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref4$pair_address = _ref4.pair_address, pair_address = _ref4$pair_address === void 0 ? undefined : _ref4$pair_address;

              if (pair_address) {
                _context5.next = 3;
                break;
              }

              throw new Error("sushi-data: Pair address undefined");

            case 3:
              _context5.next = 5;
              return pairDayData({
                pair_address: pair_address
              });

            case 5:
              data = _context5.sent;
              endTime = getUnixTime(new Date());
              startTime = getUnixTime(startOfMinute(subYears(new Date(), 1)));
              dayIndexSet = new Set();
              dayIndexArray = [];
              data.forEach(function (dayData, i) {
                // add the day index to the set of days
                dayIndexSet.add((data[i].timestamp / TWENTY_FOUR_HOURS).toFixed(0));
                dayIndexArray.push(data[i]);
              });
              timestamp = data[0].timestamp ? data[0].timestamp : startTime;
              latestLiquidityUSD = data[0].liquidityUSD;
              index = 1;

              while (timestamp < endTime - TWENTY_FOUR_HOURS) {
                nextDay = timestamp + TWENTY_FOUR_HOURS;
                currentDayIndex = (nextDay / TWENTY_FOUR_HOURS).toFixed(0);

                if (!dayIndexSet.has(currentDayIndex)) {
                  data.push({
                    id: "".concat(data[0].id.split("-")[0], "-").concat(nextDay / TWENTY_FOUR_HOURS),
                    date: new Date(nextDay * 1000),
                    timestamp: nextDay,
                    volumeUSD: 0,
                    volumeToken0: 0,
                    volumeToken1: 0,
                    liquidityUSD: latestLiquidityUSD,
                    txCount: 0
                  });
                } else {
                  latestLiquidityUSD = dayIndexArray[index].liquidityUSD;
                  index = index + 1;
                }

                timestamp = nextDay;
              }

              data = data.sort(function (a, b) {
                return parseInt(a.timestamp) > parseInt(b.timestamp) ? 1 : -1;
              });
              return _context5.abrupt("return", data);

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
};